let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hhss7"), load("dnwTC")]).then(() => parcelRequire('3Jp28'));